/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Downloadprospectstemplate3Inputs */

const en_coinvestments_downloadprospectstemplate3 = /** @type {(inputs: Coinvestments_Downloadprospectstemplate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Prospects Template`)
};

/**
* | output |
* | --- |
* | "Download Prospects Template" |
*
* @param {Coinvestments_Downloadprospectstemplate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_downloadprospectstemplate3 = /** @type {((inputs?: Coinvestments_Downloadprospectstemplate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Downloadprospectstemplate3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_downloadprospectstemplate3(inputs)
});
export { coinvestments_downloadprospectstemplate3 as "coInvestments_downloadProspectsTemplate" }